"use client";
import React, { useState } from "react";
import Faq from "../faq/Faq";
import "../../contents/scss/faq.scss";

export function Faqs(props) {
    const [showAll, setshowAll] = useState(false);

    console.log(props)


    return (
        <div>
            <div className="py-5">
                <h2 className="d-flex justify-content-start pb-3">FAQ</h2>
                <div
                    className="accordion accordion-faq"
                    id="accordionExampleFAQ">
                    {props?.faq?.faqInformation?.faqList?.slice(0, 5).map(
                        (
                            item,
                            index // Use the slice method to show only five FAQs
                        ) => (
                            <Faq
                                key={index}
                                index={index}
                                item={item}
                                id={"#accordionExampleFAQ"}
                            />
                        )
                    )}
                    {showAll && props?.faq?.faqInformation?.faqList.length > 5 && props?.faq?.faqInformation?.faqList?.slice(5).map(
                        (
                            item,
                            index // Use the slice method to show only five FAQs
                        ) => (
                            <Faq
                                key={index}
                                index={index}
                                item={item}
                                id={"#accordionExampleFAQ"}
                            />
                        )
                    )}
                </div>
                <div className="sp-btn">
                    {" "}
                    <button
                        className="btn btn-sm custom_btn mt-3"
                        
                        onClick={() => {
                            setshowAll(!showAll)
                        }}>
                        See Full FAQ
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="currentColor"
                            className="bi bi-arrow-right-short"
                            viewBox="0 0 16 16">
                            <path
                                fillRule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Faqs;
